// The routing number must be exactly 9 digits
export const testRouting = (routing: string): boolean =>
  /^\d{9}$/.test(routing);

// Check if the account number is within a typical range and only contains digits
export const testAccount = (account: string): boolean =>
  /^\d{4,17}$/.test(account);
